import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DurationField } from 'components/forms'
import { FormattedPace } from 'shared/units'
import styles from './_workoutForm.css'

export function Pace ({ formName, defaultValue }) {
  return (
    <DurationField
      bold
      short
      showHours={false}
      formName={formName}
      defaultValue={defaultValue}
      name='pace'
      labelComponent={(
        <FormattedMessage
          id='workouts.create.pace'
          defaultMessage='Pace'
        />
      )}
      afterComponent={(
        <span className={styles.fieldUnit}>
          <FormattedPace id='workouts.create.pace' />
        </span>
      )}
    />
  )
}

Pace.propTypes = {
  defaultValue: PropTypes.number,
  formName: PropTypes.string,
}

export default Pace



// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/Pace.jsx